<template>
    <div>
        <BaseModal 
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="$tc('userHeader.EmployeeDocumentTitle', this.editMode ? 1 : 2)"
            :width="'50%'"
            :height="'auto'"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK },                   
            ]"              
            @Close="close"
        >
            <b-row>
                <b-col lg="9" md="9" sm="12">         
                    <MdSelect
                        v-bind:Label="$t('employee.Document')"
                        v-bind:Options="documentTypeList"
                        v-bind:Model="editableItem.docCode"
                        v-bind:FieldDescription="'description'"
                        v-bind:FieldCode="'code'"
                        v-bind:Multiple="false"       
                        :isRequired="true"      
                        :Input="changeDropDownDocument"
                        :isValid="isValidDocument"
                        :IsDisabled="editMode"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdDateTime 
                        :Label="$t('employee.TerminateDate')" 
                        :Model="editableItem.expDate"                           
                        @input="editableItem.expDate = $event"
                        :Id="'expDate'"
                        :Type="'date'"                                 
                        :isConfirm="false"
                        :isValid="isValidDate">
                    </MdDateTime>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12" lg="12" sm="12">
                    <MdMemo
                        v-bind:Name="'description'"
                        v-bind:Rows="'8'"
                        v-bind:MaxRows="'6'"
                        :isValid="isValidComment"
                        :isRequired="true"
                        v-model="editableItem.comment"/>
                </b-col>
            </b-row>
        </BaseModal>
    </div>
</template>

<script>
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'EmployeeDocumentModal',
    mixins: [validationMixin, ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        documentTypeList: {
            type: Array,
            required: true
        },
        editMode: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            modalId: 'EmployeeProviderModal',
            emitCloseEvent: false,
            editableItem: {...this.value},
            isValidDocument: true,
            isValidDate: true,
            isValidComment: true
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
        },
        value(newVal) {
            this.isValidDocument = true;
            this.isValidDate = true;
            this.isValidComment = true;
            this.editableItem = {...newVal};
        }
    },

    methods: {
        emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate()) {
                this.$emit('update:visible', false);
                this.$emit('ok', this.editableItem);
            } else {
                bvModalEvent.preventDefault();

                this.isValidDocument = this.isValid('docCode');
                this.isValidDate = this.isValid('expDate');
                this.isValidComment = this.isValid('comment');
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent= false;
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate() {
            const rules = {
                docCode: [
                    validationRules.required(
                        this.$t("Msg.CheckRequiredFields")
                    ),
                ],
                comment: [
                    validationRules.required(
                        this.$t("Msg.CheckRequiredFields")
                    ),
                ],
                expDate: [
                    validationRules.date(
                        null,
                        this.$t("Shared.InvalidDate")
                    ),
                ]
            }

            return this.validateFields(rules, this.editableItem);
        },

        changeDropDownDocument(value) {
            this.editableItem.docCode = value ? value.code : '';
            this.editableItem.documentName = value ? value.description : '';
        }
    }
}
</script>